"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MATERIAL_SPEC_FIELD = exports.MATERIAL_TYPE_VALUES = exports.MATERIAL_TYPES = exports.ITEM_REQUIRED_FIELDS = exports.ITEM_CODE_PREFIX = exports.ITEM_CATEGORY_VALUES = exports.ITEM_CATEGORIES = void 0;
// 품목 분류 (api·web·admin 공통)
exports.ITEM_CATEGORIES = {
    FABRIC: "FABRIC", // 원단
    TRIM: "TRIM", // 부자재
    LABEL: "LABEL", // 라벨
};
exports.ITEM_CATEGORY_VALUES = Object.values(exports.ITEM_CATEGORIES);
// 품목 코드 접두사 (예: FAB-0001)
exports.ITEM_CODE_PREFIX = {
    FABRIC: "FAB",
    TRIM: "TRM",
    LABEL: "LBL",
};
// 카테고리별 필수 속성 (원단: 폭·혼용률 등 규격 필수, 라벨: 사이즈 규격 필수)
exports.ITEM_REQUIRED_FIELDS = {
    FABRIC: ["spec"],
    TRIM: [],
    LABEL: ["spec"],
};
// 자재 유형 (규격 구조 선택용, Item.type)
exports.MATERIAL_TYPES = {
    FABRIC: "fabric", // 원단
    BUTTON: "button", // 단추
    ZIPPER: "zipper", // 지퍼
    LABEL: "label", // 라벨
};
exports.MATERIAL_TYPE_VALUES = Object.values(exports.MATERIAL_TYPES);
// 자재 유형 → 사용하는 규격 필드 (Item 의 해당 컬럼만 사용)
exports.MATERIAL_SPEC_FIELD = {
    fabric: "fabricSpec",
    button: "buttonSpec",
    zipper: "zipperSpec",
    label: "labelSpec",
};
